import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainLayout from './MainLayout';
import {
	Home,
	Contact,
	Work,
	Works,
	Cabane,
	OtherProject,
	OtherProjects,
} from '..';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import axios from 'axios';
import Version from '@services/version.service';
import { useState } from 'react';
import Config from '@services/config.service';
import { set_language } from '@store/config.slice';

function App() {
	const [fetchedVersion, setFetchedVersion] = useState(false);
	const dispatch = useDispatch();
	useEffect(() => {
		const config = new Config();
		dispatch(set_language(config.get_language_from_local_storage()));
		const current_version = window.localStorage.getItem('version');
		setTimeout(() => {
			setFetchedVersion(true);
		}, 1000);

		(async () => {
			const response = await get_version();

			const fetched_version = Number.parseInt(
				response.data[0].acf['publish-version'],
			);

			if (
				response &&
				response.data.length > 0 &&
				fetched_version > Number.parseInt(current_version)
			) {
				window.localStorage.clear();
			}
			window.localStorage.setItem('version', fetched_version);
			setFetchedVersion(true);
		})();
	}, []);

	const get_version = async () => {
		return await axios.get(Version.full_url());
	};

	if (!fetchedVersion) {
		return;
	}
	return (
		<>
			<Routes>
				<Route path="/" element={<MainLayout />}>
					<Route name="home" path="/" element={<Home />} />
					<Route name="works" path="/works" element={<Works />} />
					<Route name="work" path="works/:work_slug" element={<Work />} />
					<Route name="cabane" path="/cabane" element={<Cabane />} />
					<Route
						name="otherProjects"
						path="/other-projects"
						element={<OtherProjects />}
					/>
					<Route
						name="otherProject"
						path="other-projects/:other_projects_slug"
						element={<OtherProject />}
					/>
					<Route name="contact" path="/contact" element={<Contact />} />
				</Route>
			</Routes>
		</>
	);
}

export default App;
